import { useState } from "react";
import { t } from "@/i18n";

// Zoomable, RTL Arabic text with clear diacritics. `forms` renders 4 positional
// forms using zero-width joiners when `letter` is passed.
export function ArabicText({ children, className = "", size = "text-3xl", testId, noZoom = false }) {
  const [zoom, setZoom] = useState(0);
  const sizes = ["text-2xl", "text-3xl", "text-4xl", "text-5xl", "text-6xl"];
  const base = sizes.indexOf(size) === -1 ? 1 : sizes.indexOf(size);
  const cls = sizes[Math.min(sizes.length - 1, base + zoom)] || size;
  return (
    <span className={`relative inline-flex items-center gap-2 ${className}`}>
      <span data-testid={testId} dir="rtl" className={`arabic ${cls}`}>{children}</span>
      {!noZoom && (
        <button
          type="button"
          data-testid="arabic-zoom"
          onClick={(e) => { e.stopPropagation(); setZoom((z) => (z + 1) % 3); }}
          className="opacity-40 hover:opacity-100 transition text-xs border rounded-md px-1.5 py-0.5"
          title={t("arabictext.agrandir_le_texte_arabe")}
        >A+</button>
      )}
    </span>
  );
}

const ZWJ = "\u200D";
export function LetterForms({ char, connects = true }) {
  const forms = connects
    ? [
        { label: "Isolée", v: char },
        { label: "Initiale", v: char + ZWJ },
        { label: "Médiane", v: ZWJ + char + ZWJ },
        { label: "Finale", v: ZWJ + char },
      ]
    : [
        { label: "Isolée", v: char },
        { label: "Finale", v: ZWJ + char },
      ];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {forms.map((f) => (
        <div key={f.label} className="rounded-xl border bg-card p-4 text-center">
          <div className="arabic text-4xl mb-1" dir="rtl">{f.v}</div>
          <div className="text-xs text-muted-foreground">{f.label}</div>
        </div>
      ))}
    </div>
  );
}
